import React from 'react';

import { Tooltip } from '@sumologic/yama-ds-components';

import { Moment } from 'shared/components/internal/Moment';

import css from './MatchedItem.module.scss';

interface MatchedItemProps {
  item: {
    active: boolean;
    id: string;
    listId: string;
    meta: {
      created: { username: string; when: number };
      updated?: { username: string; when: number };
      description: string;
    };
    target: string;
    value: string;
    expires?: number;
  };
}

export const MatchedItem = ({ item }: MatchedItemProps) => {
  return (
    <Tooltip title={<MatchedItemTooltip item={item} />}>
      <div>
        {item.listId}: {item.value}
      </div>
    </Tooltip>
  );
};

const MatchedItemTooltip = ({ item }: MatchedItemProps) => {
  return (
    <div className={css.tooltipContainer}>
      <div className={css.tooltipRow}>
        <span className={css.tooltipKey}>List ID: </span> {item.listId}
      </div>
      <div className={css.tooltipRow}>
        <span className={css.tooltipKey}>Value: </span>
        {item.value}
      </div>
      <div className={css.tooltipRow}>
        <span className={css.tooltipKey}>Description: </span>
        {item.meta.description}
      </div>
      <div className={css.tooltipRow}>
        <span className={css.tooltipKey}>Target: </span>
        {item.target}
      </div>
      <div className={css.tooltipRow}>
        <span className={css.tooltipKey}>Created By: </span>
        {item.meta.created.username}
      </div>
      <div className={css.tooltipRow}>
        <span className={css.tooltipKey}>Created On: </span>
        <Moment>{item.meta.created.when * 1000}</Moment>
      </div>
      {item.meta.updated && (
        <>
          <div className={css.tooltipRow}>
            <span className={css.tooltipKey}>Updated By: </span>
            {item.meta.updated.username}
          </div>
          <div className={css.tooltipRow}>
            <span className={css.tooltipKey}>Updated On: </span>
            <Moment>{item.meta.updated.when * 1000}</Moment>
          </div>
        </>
      )}
      {item.expires && (
        <div className={css.tooltipRow}>
          <span className={css.tooltipKey}>Expires On: </span>
          <Moment>{item.expires * 1000}</Moment>
        </div>
      )}
    </div>
  );
};
